var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "from",
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物品名称",
      "prop": "goods_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入物品名称"
    },
    model: {
      value: (_vm.from.goods_name),
      callback: function($$v) {
        _vm.$set(_vm.from, "goods_name", $$v)
      },
      expression: "from.goods_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物品编号",
      "prop": "goods_no"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入物品编号"
    },
    model: {
      value: (_vm.from.goods_no),
      callback: function($$v) {
        _vm.$set(_vm.from, "goods_no", $$v)
      },
      expression: "from.goods_no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物品类型",
      "prop": "type_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择物品类型",
      "clearable": ""
    },
    model: {
      value: (_vm.from.type_id),
      callback: function($$v) {
        _vm.$set(_vm.from, "type_id", $$v)
      },
      expression: "from.type_id"
    }
  }, _vm._l((_vm.lxList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格型号",
      "prop": "goods_model"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入规格型号"
    },
    model: {
      value: (_vm.from.goods_model),
      callback: function($$v) {
        _vm.$set(_vm.from, "goods_model", $$v)
      },
      expression: "from.goods_model"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物品数量",
      "prop": "model_quantity"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入颜色"
    },
    model: {
      value: (_vm.from.model_quantity),
      callback: function($$v) {
        _vm.$set(_vm.from, "model_quantity", $$v)
      },
      expression: "from.model_quantity"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色",
      "prop": "model_colour"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入颜色"
    },
    model: {
      value: (_vm.from.model_colour),
      callback: function($$v) {
        _vm.$set(_vm.from, "model_colour", $$v)
      },
      expression: "from.model_colour"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重量",
      "prop": "model_weight"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入重量"
    },
    model: {
      value: (_vm.from.model_weight),
      callback: function($$v) {
        _vm.$set(_vm.from, "model_weight", $$v)
      },
      expression: "from.model_weight"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌",
      "prop": "model_brand"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入品牌"
    },
    model: {
      value: (_vm.from.model_brand),
      callback: function($$v) {
        _vm.$set(_vm.from, "model_brand", $$v)
      },
      expression: "from.model_brand"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.from.id == null || _vm.from.id == ''),
      expression: "from.id == null || from.id == ''"
    }],
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.from.id != null && _vm.from.id != ''),
      expression: "from.id != null && from.id != ''"
    }],
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("修改")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb25d594","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xzgl/WpGl/WpGl_add.vue
// module id = null
// module chunks = 